module.exports = __webpack_public_path__ + "static/media/special-vendors.8fd55eb3.svg";